/* No-discount email signup (snippets/cc-email-signup.liquid), 2026-10-03.
   Subscribes through Klaviyo's client API, the same route cc-saved.js uses for
   the wishlist signup. Every kind joins the one "Website Signups" list; kind
   "artist" also records a "Followed Artist" event so each follow is kept (a
   profile property would be overwritten by the next follow).
   Signed-up state is per device: the new-additions band hides itself once this
   browser has signed up, and an artist the browser follows shows as followed. */
(function() {
  var SIGNUP_KEY = 'cc_signup_v1';      /* {email, at} once any signup succeeds */
  var FOLLOW_KEY = 'cc_follow_v1';      /* ["Claude Monet", ...] followed on this device */
  var SAVED_EMAIL_KEY = 'cc_saved_email_v1'; /* written by cc-saved.js */
  var REVISION = '2025-04-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function readJSON(key, fallback) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || 'null');
      return v == null ? fallback : v;
    } catch (e) {
      return fallback;
    }
  }
  function writeJSON(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function knownEmail() {
    var a = readJSON(SIGNUP_KEY, null);
    if (a && a.email) return a.email;
    var b = readJSON(SAVED_EMAIL_KEY, null);
    return b && b.email ? b.email : '';
  }
  function followed() {
    var list = readJSON(FOLLOW_KEY, []);
    return Array.isArray(list) ? list : [];
  }

  function post(path, companyId, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function(res) {
      if (!res.ok) throw new Error('http ' + res.status);
      return res;
    });
  }

  function showDone(box) {
    var form = box.querySelector('[data-cc-signup-form]');
    var fine = box.querySelector('[data-cc-signup-fine]');
    var err = box.querySelector('[data-cc-signup-error]');
    var done = box.querySelector('[data-cc-signup-done]');
    if (form) form.setAttribute('hidden', '');
    if (fine) fine.setAttribute('hidden', '');
    if (err) err.setAttribute('hidden', '');
    if (done) done.removeAttribute('hidden');
    box.classList.add('is-done');
  }

  function init() {
    var boxes = document.querySelectorAll('[data-cc-signup]');
    if (!boxes.length) return;
    var signedUp = !!readJSON(SIGNUP_KEY, null);
    var email = knownEmail();

    boxes.forEach(function(box) {
      var kind = box.dataset.kind;
      var artist = box.dataset.artist || '';

      /* Already handled on this device: the grid band steps aside entirely,
         the footer and artist rows show their confirmation instead. */
      if (kind === 'artist' && followed().indexOf(artist) !== -1) {
        showDone(box);
      } else if (kind !== 'artist' && signedUp) {
        if (box.classList.contains('cc-signup--band')) box.setAttribute('hidden', '');
        else showDone(box);
      }

      var form = box.querySelector('[data-cc-signup-form]');
      if (!form) return;
      var input = form.querySelector('input[type="email"]');
      if (email && input && !input.value) input.value = email;

      form.addEventListener('submit', function(event) {
        event.preventDefault();
        var errEl = box.querySelector('[data-cc-signup-error]');
        var btn = form.querySelector('button');
        var value = (input.value || '').trim();
        var hp = form.querySelector('.cc-signup-hp');
        if (hp && hp.value) { showDone(box); return; }
        if (!EMAIL_RE.test(value)) {
          errEl.textContent = 'Please enter a valid email address.';
          errEl.removeAttribute('hidden');
          return;
        }
        errEl.setAttribute('hidden', '');
        btn.disabled = true;
        btn.textContent = 'Sending...';

        var props = { SignupSource: box.dataset.source };
        var follows = followed();
        if (kind === 'artist') {
          if (follows.indexOf(artist) === -1) follows.push(artist);
          props.FollowedArtists = follows;
          props.LastFollowedArtist = artist;
        }

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: kind === 'artist' ? 'Artist Follow - ' + box.dataset.source : 'New Additions - ' + box.dataset.source,
              profile: { data: { type: 'profile', attributes: { email: value, properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: box.dataset.listId } } }
          }
        };

        post('subscriptions', box.dataset.companyId, payload)
          .then(function() {
            if (kind === 'artist') {
              writeJSON(FOLLOW_KEY, follows);
              /* Fire-and-forget: the list join above is what matters; the event
                 is what lets a segment pick out this artist's followers. */
              post('events', box.dataset.companyId, {
                data: {
                  type: 'event',
                  attributes: {
                    /* ArtistURL and the Work* fields feed the artist welcome email
                       (2026-10-10); blank when the page had no painting to name. */
                    properties: {
                      Artist: artist,
                      PageURL: window.location.href.split('?')[0],
                      ArtistURL: box.dataset.artistUrl || '',
                      WorkTitle: box.dataset.workTitle || '',
                      WorkURL: box.dataset.workUrl || '',
                      WorkImage: box.dataset.workImage || ''
                    },
                    metric: { data: { type: 'metric', attributes: { name: 'Followed Artist' } } },
                    profile: { data: { type: 'profile', attributes: { email: value } } }
                  }
                }
              }).catch(function() {});
            }
            writeJSON(SIGNUP_KEY, { email: value, at: new Date().toISOString() });
            try {
              var klaviyo = window.klaviyo || window._learnq;
              if (klaviyo && typeof klaviyo.push === 'function') klaviyo.push(['identify', { email: value }]);
            } catch (e) {}
            /* Every box with the same promise on the page flips together
               ('new' and 'story' share a list, so they count as one). */
            document.querySelectorAll('[data-cc-signup]').forEach(function(other) {
              var otherArtist = other.dataset.kind === 'artist';
              if (otherArtist !== (kind === 'artist')) return;
              if (kind === 'artist' && other.dataset.artist !== artist) return;
              showDone(other);
            });
            box.dispatchEvent(new CustomEvent('cc:signup-done', { bubbles: true }));
          })
          .catch(function() {
            btn.disabled = false;
            btn.textContent = btn.dataset.label || 'Sign up';
            errEl.textContent = 'Something went wrong. Please try again.';
            errEl.removeAttribute('hidden');
          });
      });
    });
  }

  /* Follow-the-artist buttons (snippets/cc-follow-dialog.liquid) open the
     follow form in a <dialog> with a painting beside it. Each button reads
     "Following <artist>" once this device follows that artist, and the dialog
     closes itself shortly after a successful follow. */
  function initFollowButtons() {
    var dialog = document.querySelector('[data-cc-follow-dialog]');
    var btns = document.querySelectorAll('[data-cc-follow-open]');
    if (!btns.length) return;
    if (!dialog || typeof dialog.showModal !== 'function') {
      btns.forEach(function(b) { (b.closest('.cc-follow-row') || b).setAttribute('hidden', ''); });
      return;
    }
    function sync() {
      btns.forEach(function(b) {
        var on = followed().indexOf(b.dataset.artist) !== -1;
        b.textContent = on ? '✓ Following ' + b.dataset.artist : b.dataset.label;
        b.classList.toggle('is-following', on);
      });
    }
    sync();
    btns.forEach(function(b) {
      b.addEventListener('click', function() {
        dialog.showModal();
        var input = dialog.querySelector('input[type="email"]');
        if (input && !dialog.querySelector('.is-done')) input.focus();
      });
    });
    dialog.querySelectorAll('[data-cc-follow-close]').forEach(function(c) {
      c.addEventListener('click', function() { dialog.close(); });
    });
    /* A click on the backdrop lands on the dialog element itself. */
    dialog.addEventListener('click', function(e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('cc:signup-done', function() {
      sync();
      var nt = dialog.querySelector('.cc-follow-nothanks');
      if (nt) nt.setAttribute('hidden', '');
      setTimeout(function() { if (dialog.open) dialog.close(); }, 2200);
    });
    dialog.addEventListener('close', sync);
  }

  function start() {
    init();
    initFollowButtons();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
